module.exports = __webpack_public_path__ + "img/021-sign language.5ecf314b.svg";